/**
 * Combines separate user calculations into a total
 * @param {Array} calculation Array of individual calculations
 * @returns {Object} Combined totals with direct assigned and summed values
 */
export const getSeparatedUserCalculationsTotal = (calculation) => {
  const directAssignKeys = new Set([
    "pensionPercentage",
    "vatPercentage",
    "pensionFeePer",
    "socialFeeRateDeduction",
    "fakturaFeePercentage",
    "taxRateDeduction",
    "currencyMarginPercentage"
  ]);

  return calculation.reduce((total, current) => {
    Object.keys(current || {}).forEach((key) => {
      if (!total[key]) {
        total[key] = 0;
      }
      total[key] = directAssignKeys.has(key) 
        ? (current[key] || 0) 
        : (total[key] + (current[key] || 0));
    });
    return total;
  }, {});
};